require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-el-banco-mundial-acaba-de-aprobar-una-nueva-politica.json") })
        }
      }, "path---es-mx-update-el-banco-mundial-acaba-de-aprobar-una-nueva-politica");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-el-banco-mundial-acaba-de-aprobar-una-nueva-politica!./.cache/json/es-mx-update-el-banco-mundial-acaba-de-aprobar-una-nueva-politica.json
// module id = 927
// module chunks = 231608221292675